<template>
  <div class="editor-container">
    <div class="header">
      <button class="back-btn" @click="goBack">
        <span>←</span> 返回
      </button>
      <h1>取件表零件标记</h1>
    </div>
    
    <div class="content-wrapper" :style="'height:'+screenHeight+'px'">
      <div class="image-area">
        <image-marker
          ref="imageMarker"
          :image-path="imageUrl"
          :scroll-top="scrollTop"
          :markers="markers"
          @update:markers="updateMarkers"
          @update:currentbox="updateCurrentBox"
          @update:currentindex="updateCurrentIndex"
          @edit-marker="editMarker"
          @delete-marker="deleteMarker"
          @marker-created="onMarkerCreated"
          @marker-clicked="onMarkerClicked"
        />
      </div>
      
      <div class="control-area">
        <div class="submit-area">
          <button class="primary-btn" @click="showIdentifyDialog">开始识别</button>
          <button class="primary-btn" @click="saveData">保存并返回</button>
        </div>
        
        <div class="table-container">
          <data-table
            ref="dataTable"
            :columns="columns"
            :data="markers"
            :show-header="true"
            :stripe="true"
            :border="true"
            :show-edit-button="false"
            :show-delete-button="false"
            :active-row="currentIndex"
            @update:active-row="updateActiveRow"
            @cell-click="cellClick"
          />
        </div>
      </div>
    </div>
    
    <!-- 编辑弹窗 -->
    <modal-popup 
      :visible.sync="showEditModal"
      title="编辑标注"
      width="600"
      @confirm="confirmEdit"
    >
      <div class="popup-content">
        <div class="form-item">
          <label class="title">【部件】</label>
          <select v-model="tableMarkers.type" @change="bindPickerChange" class="form-select">
            <option v-for="(item, idx) in partTypes" :key="idx" :value="item">{{item}}</option>
          </select>
          <div class="button-group">
            <button @click="setHoldPageType" class="mini-btn">整页一样</button>
            <button @click="downSetHoldPageType" class="mini-btn">向下填充</button>
          </div>
        </div>
        
        <div class="form-item">
          <label class="title">【数量】</label>
          <input 
            v-model="tableMarkers.num" 
            @input="bindNumChange" 
            class="form-input" 
            type="number" 
            maxlength="3" 
            placeholder="1" 
          />
          <button @click="downSetHoldPageNum" class="mini-btn">向下填充</button>
        </div>
        
        <div class="form-item">
          <label class="title">【零件号】</label>
          <input 
            v-model="tableMarkers.content" 
            @input="bindPartChange" 
            class="form-input" 
            maxlength="10" 
            placeholder="先自动识别,出错再改" 
          />
        </div>
      </div>
    </modal-popup>
    
    <!-- 识别确认弹窗 -->
    <confirm-dialog 
      :visible.sync="showIdentifyModal"
      title="选择"
      content="是否从头开始识别"
      cancel-text="重新开始"
      confirm-text="继续(空白的列)"
      @confirm="continueIdentify"
      @cancel="blankIdentify"
    />
    
    <!-- 加载提示 -->
    <loading-overlay :visible="isLoading" :message="loadingMessage" />
  </div>
</template>

<script>
import api from '@/api';
import axios from 'axios';
import ImageMarker from '@/components/ImageMarker.vue';
import DataTable from '@/components/DataTable.vue';
import ModalPopup from '@/components/ModalPopup.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import { getStorageSync } from '@/utils/uni-app';

export default {
  components: {
    ImageMarker,
    DataTable,
    ModalPopup,
    ConfirmDialog,
    LoadingOverlay
  },
  name: 'Editor',
  data() {
    return {
      id: 0,
      scrollTop: 0,
      screenHeight: 0,
      screenWidth: 0,
      imageUrl: "",
      markers: [{
        height: 0, 
        width: 0, 
        x: 0, 
        y: 0,
        type: "",
        num: 1,
        content: "",
        picsrc: "",
      }],
      currentIndex: 0,
      currentBox: {
        height: 19.8,
        width: 18.8, 
        x: 21.6, 
        y: 39.4,
        type: "",
        num: 1,
        content: "",
        picsrc: "",
      },
      partTypes: ['', '头', '身躯', '腰', '肩甲', '手臂', '左臂', '右臂', '腿', '脚', '左腿', '右腿', '武器1', '武器2', '武器3', '背包1', '背包2', '盾牌', '其他配件', '头-骨架', '身躯-骨架', '腰-骨架', '手臂-骨架', '腿-骨架'],
      partTypeIndex: 0,
      columns: [
  { name: 'picsrc', label: '图片', type: "img", width: 100 },
  { name: 'type', label: '部件', width: 80, emptyString: '--' },
  { name: 'num', label: '数量', width: 100, align: 'right' },
  { name: 'content', label: '零件号', width: 150, emptyString: '' },
],
      tableIndex: 0,
      tableMarkers: [],
      showEditModal: false,
      showIdentifyModal: false,
      isLoading: false,
      loadingMessage: "加载中"
    }
  },
  mounted() {
    // 获取屏幕高度
    this.screenHeight = window.innerHeight - 100; // 减去头部高度
    this.screenWidth = window.innerWidth;
    
    // 获取路由参数
    this.id = this.$route.params.id || this.$route.query.id || 0;
    
    // 加载页面信息
    this.getPageInfo(this.id);
    
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    
    // 处理滚动事件
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    },
    
    // 获取页面信息
    getPageInfo(id) {
      if (!id || id === 0) {
        this.showMessage("无效的页面ID", "error");
        return;
      }
      
      this.isLoading = true;
      this.loadingMessage = "加载中";
      
      api({ method: 'post', url: '/liner/Getpageinfo', data: { id } })
      .then(response => {
        const data = response;
        if (data.code == 200) {
          const pageInfo = this.normalizePageInfo(data.data);
          this.imageUrl = pageInfo.picpath || "";
          this.markers = this.parseTestinfo(pageInfo.testinfo);
        } else {
          this.showMessage("网络错误", "error");
        }
      })
      .catch(error => {
        console.error('获取页面信息失败:', error);
        this.showMessage("网络错误", "error");
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    
    // 保存数据
    saveData() {
      this.isLoading = true;
      this.loadingMessage = "保存中";
      
      this.matchMarkers();
      
      api.formPost('/liner/Savetestinfo', { id: this.id, testinfo: JSON.stringify(this.markers) })
      .then(response => {
        const data = response;
        if (data.code == 200) {
          this.showMessage("提交完成", "success");
        } else {
          this.showMessage("网络错误", "error");
        }
      })
      .catch(error => {
        console.error('保存数据失败:', error);
        this.showMessage("网络错误", "error");
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    normalizePageInfo(payload) {
      if (payload && payload.data && typeof payload.data === "object" && !Array.isArray(payload.data)) {
        return payload.data;
      }
      return payload || {};
    },

    parseTestinfo(testinfo) {
      if (Array.isArray(testinfo)) {
        return testinfo;
      }
      if (!testinfo || typeof testinfo !== "string") {
        return [];
      }

      const text = testinfo.trim();
      if (!text || text === "null") {
        return [];
      }

      try {
        const parsed = JSON.parse(text);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error("解析页面标记失败:", error, testinfo);
        this.showMessage("页面标记数据格式错误", "error");
        return [];
      }
    },
    
    // 设置整页类型
    setHoldPageType() {
      if (this.tableMarkers.type != "") {
        const partType = this.tableMarkers.type;
        this.markers.forEach((item, index) => {
          this.markers[index].type = partType;
        });
        this.showMessage("修改完成", "success");
      } else {
        this.showMessage("不能为空", "warning");
      }
    },
    
    // 选择器变化事件
    bindPickerChange(e) {
      this.partTypeIndex = e.target.value;
      this.markers[this.tableIndex].type = this.partTypes[this.partTypeIndex];
      // 更新标记的裁剪URL
      this.markers[this.tableIndex] = this.updateMarkerCropUrl(this.markers[this.tableIndex]);
    },
    
    // 数量输入变化
    bindNumChange(e) {
      this.markers[this.tableIndex].num = e.target.value;
      // 更新标记的裁剪URL
      this.markers[this.tableIndex] = this.updateMarkerCropUrl(this.markers[this.tableIndex]);
    },
    
    // 零件号输入变化
    bindPartChange(e) {
      this.markers[this.tableIndex].content = e.target.value;
      // 更新标记的裁剪URL
      this.markers[this.tableIndex] = this.updateMarkerCropUrl(this.markers[this.tableIndex]);
    },
    
    // 编辑标记
    editMarker(item, index) {
      this.tableIndex = index;
      this.tableMarkers = {...item};
      this.showEditModal = true;
    },
    
    // 删除标记
    deleteMarker(item, index) {
      // 使用传入的index参数直接删除
      if (index >= 0 && index < this.markers.length) {
        this.markers.splice(index, 1);
        // 如果删除的是当前选中的标记，重置选中状态
        if (this.currentIndex === index) {
          this.currentIndex = -1;
          this.currentBox = null;
        } else if (this.currentIndex > index) {
          // 如果删除的标记在当前选中标记之前，更新当前选中索引
          this.currentIndex--;
        }
      }
    },
    
    // 更新标记的裁剪URL
    updateMarkerCropUrl(marker) {
      if (!marker) {
        return marker;
      }
      
      // 如果图片还未加载完成，延迟处理
      if (!this.$refs.imageMarker || !this.$refs.imageMarker.$refs.markerImage || !this.$refs.imageMarker.imageLoaded) {
        // 使用setTimeout延迟处理，等待图片加载完成
        setTimeout(() => {
          if (this.$refs.imageMarker && this.$refs.imageMarker.imageLoaded) {
            const index = this.markers.findIndex(m => m === marker);
            if (index !== -1) {
              this.markers[index] = this.updateMarkerCropUrl(marker);
            }
          }
        }, 500);
        return marker;
      }
      
      // 获取原始图片尺寸
      const image = this.$refs.imageMarker.$refs.markerImage;
      const imageWidth = image.naturalWidth;
      const imageHeight = image.naturalHeight;
      
      // 计算原始图片上的坐标
      const originalX = Math.round((marker.x / 100) * imageWidth);
      const originalY = Math.round((marker.y / 100) * imageHeight);
      const originalWidth = Math.round((marker.width / 100) * imageWidth);
      const originalHeight = Math.round((marker.height / 100) * imageHeight);
      
      // 生成带有OSS裁剪参数的URL
      // 检查URL是否已包含参数
      const hasQueryParams = this.imageUrl.includes('?');
      let croppedImageUrl;
      
      if (hasQueryParams) {
        // 如果已有查询参数，在现有参数后添加裁剪参数
        croppedImageUrl = `${this.imageUrl},image/crop,x_${originalX},y_${originalY},w_${originalWidth},h_${originalHeight}`;
      } else {
        // 如果没有查询参数，添加裁剪参数
        croppedImageUrl = `${this.imageUrl}?x-oss-process=image/crop,x_${originalX},y_${originalY},w_${originalWidth},h_${originalHeight}`;
      }
      
      // 返回更新后的标记，更新picsrc为裁剪后的URL，保留croppedPicsrc用于标记框预览
      return {
        ...marker,
        picsrc: croppedImageUrl
      };
    },
    
    // 表格单元格点击
    cellClick(item, index, column) {
      this.tableIndex = index;
      this.tableMarkers = {...item};
      this.showEditModal = true;
      
      // 通知ImageMarker组件更新选中状态
      this.$refs.imageMarker.selectMarker(index);
    },
    
    // 返回零件号
    returnPartNum(flag) {
      let picpath = [];
      
      if (flag == 0) { // 继续识别
        this.isLoading = true;
        this.loadingMessage = "继续识别中...";
        
        // 获取没有content的markers
        const urls = this.markers
          .filter(marker => marker.content === "")
          .map(marker => marker.picsrc);
        
        if (urls.length == 0) {
          this.isLoading = false;
          this.showMessage("没有空记录", "warning");
          return false;
        }
        
        api({ method: 'post', url: '/liner/Pinjieimage', data: { urls }, timeout: 900000 })
        .then(response => {
          const data = response;
          if (data.code == 200) {
            const newContentArray = data.data.partnum;
            const emptyContentMarkers = this.markers.filter(marker => marker.content === "");
            
            emptyContentMarkers.forEach((marker, index) => {
              marker.content = newContentArray[index];
            });
            
            console.log(this.markers);
          } else {
            this.showMessage(data.msg, "error");
          }
        })
        .catch(error => {
          console.error('识别失败:', error);
          this.showMessage("网络错误", "error");
        })
        .finally(() => {
          this.isLoading = false;
        });
      } else { // 从头开始识别
        if (this.markers.length > 20) {
          picpath = this.markers.slice(0, 20).map(item => item.picsrc);
          this.isLoading = true;
          this.loadingMessage = "首次提交零件号过多，先识别前20条，稍后请继续点击识别剩下空白的零件号";
        } else {
          picpath = this.markers.map(item => item.picsrc);
          this.isLoading = true;
          this.loadingMessage = "识别中...";
        }
        
        api({ method: 'post', url: '/liner/Pinjieimage', data: { urls: picpath }, timeout: 900000 })
        .then(response => {
          const data = response;
          if (data.code == 200) {
            const partnum = data.data.partnum;
            const partnumLength = partnum.length;
            
            if (picpath.length === partnumLength) {
              for (let index = 0; index < partnumLength; index++) {
                this.markers[index].content = partnum[index];
              }
            } else {
              console.error('markers 数组和 partnum 数组长度不匹配');
              this.showMessage("数组长度不匹配", "error");
            }
          } else {
            this.showMessage(data.msg, "error");
          }
        })
        .catch(error => {
          console.error('识别失败:', error);
          this.showMessage("网络错误", "error");
        })
        .finally(() => {
          this.isLoading = false;
        });
      }
    },
    
    // 显示识别对话框
    showIdentifyDialog() {
      this.showIdentifyModal = true;
    },
    
    // 继续识别
    continueIdentify() {
      this.showIdentifyModal = false;
      this.returnPartNum(0);
    },
    
    // 从头开始识别
    blankIdentify() {
      this.showIdentifyModal = false;
      this.returnPartNum(1);
    },
    
    // 向下设置类型
    downSetHoldPageType() {
      if (this.tableMarkers.type != "") {
        const partType = this.tableMarkers.type;
        this.markers.forEach((item, index) => {
          if (index > this.tableIndex) {
            this.markers[index].type = partType;
          }
        });
        this.showMessage("修改完成", "success");
      } else {
        this.showMessage("不能为空", "warning");
      }
    },
    
    // 向下设置数量
    downSetHoldPageNum() {
      if (this.tableMarkers.num != "") {
        const partNum = this.tableMarkers.num;
        this.markers.forEach((item, index) => {
          if (index > this.tableIndex) {
            this.markers[index].num = partNum;
          }
        });
        this.showMessage("修改完成", "success");
      } else {
        this.showMessage("不能为空", "warning");
      }
    },
    
    // 匹配markers，确保所有字段都存在
    matchMarkers() {
      const defaultValues = {
        height: 0,
        width: 0,
        x: 0,
        y: 0,
        type: "",
        num: 1,
        content: "",
        picsrc: this.imageUrl
      };
      
      this.markers = this.markers.map(marker => {
        return { ...defaultValues, ...marker };
      });
    },
    
    // 标记创建完成后的回调
    onMarkerCreated(marker) {
      console.log(marker);
      // 标记创建后不再自动打开编辑弹窗，用户需要点击表格单元格来编辑
    },
    
    // 更新markers
    updateMarkers(markers) {
      this.markers = markers;
    },
    
    // 更新当前框
    updateCurrentBox(box) {
      this.currentBox = box;
    },
    
    // 处理标记框点击
    onMarkerClicked(index) {
      this.currentIndex = index;
      // 通知表格组件更新高亮行
      this.$refs.dataTable.setActiveRow(index);
    },
    
    // 更新当前索引
    updateCurrentIndex(index) {
      this.currentIndex = index;
    },
    
    // 更新活动行
    updateActiveRow(index) {
      this.currentIndex = index;
      // 通知ImageMarker组件更新选中状态
      this.$refs.imageMarker.selectMarker(index);
    },
    
    // 确认编辑
    confirmEdit() {
      // 更新markers数组中对应索引的数据
      if (this.tableIndex >= 0 && this.tableIndex < this.markers.length) {
        // 使用Vue.set确保响应式更新
        this.$set(this.markers, this.tableIndex, {...this.tableMarkers});
      }
      // 关闭编辑弹窗
      this.showEditModal = false;
    },
    
    // 关闭编辑弹窗
    closeEditModal() {
      this.showEditModal = false;
    },
    
    // 显示消息提示
    showMessage(message, type = "info") {
      // 这里可以使用更复杂的提示组件，暂时使用简单的alert
      if (type === "error") {
        alert(`错误: ${message}`);
      } else if (type === "warning") {
        alert(`警告: ${message}`);
      } else {
        alert(message);
      }
    }
  }
}
</script>

<style scoped>
.editor-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  padding: 15px;
  background-color: #f9f9ff;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.header {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: white;
  border-radius: 15px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 15px;
  background-color: #6a5acd;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  margin-right: 20px;
  font-weight: 500;
  transition: all 0.3s;
}

.back-btn:hover {
  background-color: #5544b8;
  transform: translateY(-2px);
}

.header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  color: #6a5acd;
}

.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
  gap: 20px;
}

.image-area {
  width: 60%;
  height: 100%;
  overflow: auto;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
}

.control-area {
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
}

.submit-area {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.primary-btn {
  padding: 8px 15px;
  background-color: #6a5acd;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.primary-btn:hover {
  background-color: #5544b8;
  transform: translateY(-2px);
}

.table-container {
  flex: 1;
  overflow: auto;
}

.popup-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
  max-width: 500px;
  margin: 0 auto;
}

.form-item {
  margin-bottom: 20px;
}

.title {
  display: block;
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: bold;
}

.form-select, .form-input {
  width: 100%;
  padding: 8px 15px;
  border: 1px solid #e8e8ff;
  border-radius: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  background-color: #f9f9ff;
  transition: all 0.3s;
}

.form-select:focus, .form-input:focus {
  border-color: #6a5acd;
  outline: none;
  box-shadow: 0 0 0 2px rgba(106, 90, 205, 0.2);
}

.button-group {
  display: flex;
  gap: 10px;
}

.mini-btn {
  padding: 5px 10px;
  background-color: #e8e8ff;
  color: #6a5acd;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s;
}

.mini-btn:hover {
  background-color: #d0d0ff;
  transform: translateY(-1px);
}

.marker-controls {
  padding: 15px;
  background-color: #f9f9ff;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 15px;
  margin: 15px;
}

.drawing-hint {
  color: #6a5acd;
  font-size: 14px;
  font-weight: 500;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>
